import React from "react";
import AuctionStats from "./auction/AuctionStats";
import AuctionProcess from "./auction/AuctionProcess";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const AuctionSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const section = labels.menuPages?.sellCar?.auctionSection || {};
  const title = section.title ?? "BEA Auktioner - Marknadsledande";
  const description =
    section.description ??
    "Genom vårt partnerskap med BEA Auktioner når vi tusentals verifierade köpare och garanterar bästa möjliga pris för din bil.";

  return (
    <section
      id="auction-section"
      className="relative py-20 bg-gradient-to-b from-gray-50 to-white overflow-hidden"
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            {title}
          </h2>
          <p className="text-xl max-w-4xl mx-auto leading-relaxed text-gray-600">
            {description}
          </p>
        </div>

        <AuctionStats />
        <AuctionProcess />
      </div>
    </section>
  );
};

export default AuctionSection;
